import React from "react";
import Footer from "../Common/Footer";
import AulasVivas from "../VariosCongreso/AulasVivas";
import Talleres from "../VariosCongreso/Talleres";

class Horario extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-title-area item-bg1">
          <div className="container">
            <h1>Talleres</h1>
            <span>Talleres y Aulas Vivas</span>
          </div>
        </div>
        <section className="partner-area ponentes ptb-120">
          <div className="container">
            <Talleres />
            <div>
              <br />
              *En caso de elegir este taller, hágalo solamente en uno de los
              bloques, ya que se impartirá el mismo las tres veces.
              <br />
            </div>
            <AulasVivas />
          </div>
        </section>
        <Footer />
      </React.Fragment>
    );
  }
}

export default Horario;
